import styled from 'styled-components';

import colors from 'themes/Main';

const { white, success, blue, danger } = colors;

export const Container = styled.div`
  display: ${({ modalVisibility }) => (modalVisibility ? 'block' : 'none')};
  z-index: 50;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.6);
`;

export const Overlay = styled.div`
  position: relative;
  margin: 0 auto;
  top: 50%;
  transform: translateY(-50%);
  width: 500px;
  padding: 32px;
  box-shadow: 0px 7px 8px rgba(0, 0, 0, 0.2), 0px 5px 22px rgba(0, 0, 0, 0.12),
    0px 12px 17px rgba(0, 0, 0, 0.14);
  background-color: ${white};
  border-radius: 10px;
  text-align: center;
`;

export const OverlayIcon = styled.img``;

export const OverlayText = styled.p`
  margin: 20px 0 32px;
  font-size: 16px;
  line-height: 22px;
  text-align: left;

  span {
    font-weight: 700;
  }

  &.overlay-information-text {
    span {
      color: ${blue};
    }
  }

  &.overlay-warning-text {
    span {
      color: ${danger};
    }
  }

  &.overlay-success-text {
    span {
      color: ${success};
    }
  }
`;

export const OverlayButtons = styled.div`
  display: flex;
  align-items: center;

  &.overlay-information-buttons {
    justify-content: center;
  }

  &.overlay-warning-buttons,
  &.overlay-success-buttons {
    justify-content: flex-end;

    button:first-child {
      margin-right: 32px;
    }
  }
`;
